import { IsString, MaxLength, IsOptional, IsArray, MinLength } from 'class-validator';

export class ProductCheckpointQuestionSearchDTO {

    @IsOptional()
    @MaxLength(50)
    question: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    checkpoints: Array<string>;

}
